import { render, staticRenderFns } from "./DeductionManagement.vue?vue&type=template&id=7fecc378"
import script from "./DeductionManagement.vue?vue&type=script&lang=js"
export * from "./DeductionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports